import { Add } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const Datahubdashboard = () => {
  return (
      <div className='content'>
          <Box 
              sx={{
                  width:'100%',
                  display: "flex",
                  justifyContent: "end",
              }}
          
          >
              <Link to="/datahub/create/data">
                  <Button
                      variant="contained"
                      startIcon={<Add />}
                      color="success"
                      sx={{
                          ml: 2, px: 2,
                          "&:hover": { backgroundColor: "#2FB354" },
                      }}
                  >
                      Add Data
                  </Button>
                  </Link>
          </Box>
      </div>
  )
}

export default Datahubdashboard